import React, { useState } from "react";
import { IconProps } from "react-bootstrap-icons";
import { NavLink, useNavigate } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface MyIconProps {
    size?: number;
    strokeWidth?: number;
}

interface CollapsibleMenuItemProps {
    icon: React.ReactElement<MyIconProps>;
    to: string;
    text: string;
    /** Optional badge (e.g. "Monthly", "Transient") shown to the right of the label; also in collapsed tooltip */
    subtext?: string;
    default?: boolean;
    active?: boolean;
    onClick?: (e: React.MouseEvent) => void;
    isCollapsed?: boolean;
    special?: boolean; // For "Back to..." items with pink styling
}

export function CollapsibleMenuItem(props: CollapsibleMenuItemProps) {
    const navigate = useNavigate();
    const isCollapsed = props.isCollapsed || false;
    
    const iconWithProps = React.cloneElement<IconProps>(props.icon, {
        size: props.icon.props.size !== undefined ? 20 : props.icon.props.size,
    });

    const handleClick = (e: React.MouseEvent, isActive: boolean) => {
        if (props.onClick) {
            e.preventDefault();
            props.onClick(e);
            return;
        }

        if (isActive) {
            e.preventDefault();
            return;
        }

        navigate(props.to);
    };

    const menuItem = (
        <NavLink
            to={props.to}
            onClick={(e) => {
                const isActive = e.currentTarget.className.includes('active');
                handleClick(e, isActive);
            }}
            className={({ isActive }) => 
                `step-${props.text.toLocaleLowerCase()} collapsible-menu-item ${isActive ? "active" : ""} ${props.special ? "special" : ""} ${isCollapsed ? "collapsed" : ""}`
            }
            end={props.default}
        >
            <div className="menu-icon-wrapper">
                {iconWithProps}
            </div>
            {!isCollapsed && (
                <div className="menu-text">
                    <span>{props.text}</span>
                    {props.subtext && <span className="menu-item-badge">{props.subtext}</span>}
                </div>
            )}
        </NavLink>
    );

    // Show tooltip only when collapsed
    if (isCollapsed) {
        return (
            <OverlayTrigger
                placement="right"
                overlay={
                    <Tooltip id={`tooltip-${props.text}`} className="menu-tooltip">
                        {props.subtext ? `${props.text} — ${props.subtext}` : props.text}
                    </Tooltip>
                }
            >
                {menuItem}
            </OverlayTrigger>
        );
    }

    return menuItem;
}

